import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

import MainLayout from '../../Layout/main';

import Header from '../../Components/header-interna';
import ConteudoPrincipal from './Sections/conteudo-principal';
import Video from './Sections/video';
import Informacoes from './Sections/informacoes';
import AgendaEventos from './Sections/agenda-de-eventos';
import Formulario from './Sections/formulario';
import { EventInterface, PageSejaExpositorInterface } from '../../Services/types';
import { fetchData } from '../../../Api';
import Galeria from '../../Components/galeria';

const Expositor: React.FC<any> = ({initialData} : any) => {
    function proccessEvents()
    {        
        if (initialData == null || initialData?.events === undefined) return;
        const formattedEvents = initialData.events.map((event: EventInterface) => ({
            ...event,
            data: new Date(event.data),
        }));                    
                            
        return formattedEvents;
    }

    const [events, setEvents] = useState<EventInterface[]>(proccessEvents());
    const [expositor, setExpositor] = useState<PageSejaExpositorInterface | null>(initialData?.expositor);
    
    useEffect(() => {
        if (initialData?.expositor) return;
        const loadData = async () => {
            const response = await fetchData("seja-um-expositor");
            if(response){
                if (response.events) {
                    const formattedEvents = response.events.map((event: EventInterface) => ({
                        ...event,
                        data: new Date(event.data),
                    }));
                    setEvents(formattedEvents);
                }
                if (response.expositor) { setExpositor(response.expositor) };
            }
        };
        
        loadData();
    }, []);

    const title = 'Seja um expositor';

    const breadcrumb = [{
        name: title,
        slug: 'seja-um-expositor'
    }];

    return (
        <>
            <Helmet>
                <title>{title} - Uniexpo</title>
            </Helmet>

            <MainLayout>
                <Header title={title} breadcrumb={breadcrumb} image={expositor ? expositor.imagem : ''} />
                {expositor && 
                    <>
                        <ConteudoPrincipal expositor={expositor}/>
                        {expositor.galeria.length > 0 &&
                            <Galeria galeria={expositor.galeria} />
                        }

                        <Informacoes />
                        
                        {expositor.video &&
                            <Video video={expositor.video} title={expositor.titulo_video} />
                        }
                        {events && 
                            <AgendaEventos events={events}/>                        
                        }
                        <Formulario />
                    </>
                }
            </ MainLayout>
        </>
    );
};

export default Expositor;
